import { Analytics } from '@client/analytics/helpers/Analytics';
import { useLogoutAnalytics } from '@client/analytics/hooks';
import { SERVER_ROUTES } from '@client/routes/components/Router/routes';
import { simulateLinkClick } from '@client/routes/utils/url';

// Give the tealium link event (delayed in the saga) time to fire before the full-page navigation.
const NAVIGATION_DELAY = Analytics.delayTealiumEvent + 50;

export const useLogoutAction = (): () => void => {
  const trackLogout = useLogoutAnalytics();

  return () => {
    trackLogout();
    setTimeout(() => simulateLinkClick(SERVER_ROUTES.logout), NAVIGATION_DELAY);
  };
};
